"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.actions = exports.types = exports.ELEMENT_TYPES = void 0;
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable default-param-last   */
const deepmerge_1 = __importDefault(require("deepmerge"));
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";
exports.ELEMENT_TYPES = {
    MODAL: 'MODAL',
};
exports.types = {
    /* MODALS */
    INIT_ANCHOR_MODAL: 'MODALS/INIT_ANCHOR_MODAL',
    ADD_MODAL: 'MODALS/ADD_MODAL',
    // almacenar backup funcion
    SET_MODAL_HISTORY: 'MODALS/SET_MODAL_HISTORY',
    /* nextjs */
    HYDRATE: 'MAIN/HYDRATE',
};
exports.actions = {
    /* SSEO */
    initAnchorModalListener: () => ({
        type: exports.types.INIT_ANCHOR_MODAL,
    }),
    addModal: (data) => ({
        type: exports.types.ADD_MODAL,
        data,
    }),
    setModalHistory: (data) => ({
        type: exports.types.SET_MODAL_HISTORY,
        data,
    }),
};
const initialState = {
    appliedScrollPolyfill: false,
    currentIdElement: '',
    currentType: '',
    modalHistory: [],
};
function AnchorModalsReducer(state = Object.assign({}, initialState), action) {
    switch (action.type) {
        case HYDRATE: {
            const { main } = action.payload;
            /* neceisto preservar lo que viene del sever excepto los filtros */
            const nextState = (0, deepmerge_1.default)(state, main);
            return nextState;
        }
        case exports.types.ADD_MODAL: {
            const { type, id } = action.data;
            return Object.assign(Object.assign({}, state), { currentIdElement: id, currentType: type });
        }
        case exports.types.SET_MODAL_HISTORY:
            return Object.assign(Object.assign({}, state), { modalHistory: action.data });
        default:
            return state;
    }
}
exports.default = AnchorModalsReducer;
//# sourceMappingURL=index.js.map